import api from './client';

export const emailConfigApi = {
  getConfig: () => api.get('/admin/email-config'),
  setTier: (tier) => api.put('/admin/email-config/tier', { tier }),
  saveByosmtp: (data) => api.put('/admin/email-config/byosmtp', data),
  testByosmtp: () => api.post('/admin/email-config/byosmtp/test'),
  initiateOAuth: (provider) => api.put('/admin/email-config/connected-email', { provider }),
  disconnectOAuth: () => api.delete('/admin/email-config/connected-email'),
  initiateDomainVerification: (domain, from_email) => api.post('/admin/email-config/verified-domain', { domain, from_email }),
  checkDomainVerification: () => api.post('/admin/email-config/verified-domain/check'),
  removeDomain: () => api.delete('/admin/email-config/verified-domain'),
  confirmBaa: (confirmed) => api.put('/admin/email-config/baa', { confirmed }),
  getAuditLog: (params) => api.get('/admin/email-config/audit', { params }),
  exportAuditCsv: (params) => api.get('/admin/email-config/audit/export', { params, responseType: 'blob' }),
};
